// "Add time" window (QA batch 15, TIME-015): time already worked, typed in by
// hand. Same duration rules as Edit Time; the server checks them too
// (backend `Services/ManualTimeRules.cs`).
import { durationProblem, EDIT_TIME_DATE_PROBLEM } from "./editTime.utils";

export const ADD_TIME_PICK_WORK = "Pick a client and a work item first";
export const ADD_TIME_FUTURE = "The date can't be in the future.";

type Picked = { value?: string | null } | null | undefined;

const startOfDay = (date: Date) =>
  new Date(date.getFullYear(), date.getMonth(), date.getDate());

/** Why the window can't save yet, or "" when it can. */
export const addTimeProblem = (input: {
  contact: Picked;
  work: Picked;
  date: Date | null;
  duration: { h: string; m: string };
  today?: Date;
}): string => {
  if (!input.contact?.value || !input.work?.value) return ADD_TIME_PICK_WORK;
  if (!input.date || Number.isNaN(input.date.getTime())) {
    return EDIT_TIME_DATE_PROBLEM;
  }
  if (startOfDay(input.date) > startOfDay(input.today ?? new Date())) {
    return ADD_TIME_FUTURE;
  }
  return durationProblem(input.duration);
};

/**
 * The work type's "Time Billing" default (Settings > Work types), like the
 * timer: true / false, or billable when the work type has no default.
 */
export const billableDefaultFor = (
  workTypeId: string | undefined,
  workTypes: { id: string; billableDefault?: boolean | null }[] | undefined,
): boolean =>
  workTypes?.find((type) => type.id === workTypeId)?.billableDefault ?? true;

/** The picked day at 12:00 local time, so the day doesn't shift in UTC. */
export const entryDateIso = (date: Date): string =>
  new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
    12,
    0,
    0,
  ).toISOString();

export const durationSeconds = (duration: { h: string; m: string }): number =>
  (parseInt(duration.h || "0", 10) || 0) * 3600 +
  (parseInt(duration.m || "0", 10) || 0) * 60;
